import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import { getProdutosEstoque } from "../queries/getEstoque";

export default function useGetProdutosEstoque(ProdutoId : number) {
  const resultQuery = useQuery(
    [`${URLS.ESTOQUE_API}`, {
      params: {ProdutoId}
    }], 
    () => getProdutosEstoque(ProdutoId));

  return resultQuery;
}
